import { HTMLProps, useEffect, useRef } from 'react';
import { Checkbox, CheckboxChangeEvent } from '../../atoms';

export const IndeterminateCheckbox = ({
  indeterminate,
  className = '',
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) => {
  const ref = useRef<HTMLInputElement>(null!);

  useEffect(() => {
    if (typeof indeterminate === 'boolean') {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <Checkbox
      inputRef={ref}
      checked={rest.checked as boolean}
      onChange={rest.onChange as ((e: CheckboxChangeEvent) => void) | undefined}
      disabled={rest.disabled}
      className={className}
    />
  );
};
